module.exports = __webpack_public_path__ + "static/media/icon_landscape.afb2101a.svg";